// extracted by mini-css-extract-plugin
module.exports = {"move-btns":"ArrowBtns_move-btns__2H8hj","move-btn":"ArrowBtns_move-btn__1Xt70","tool-tip":"ArrowBtns_tool-tip__1jlcf"};